var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineGym(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4182",
    "data-name": "Group 4182",
    transform: "translate(2168 5573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829",
    transform: "translate(-2326 -5682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M29.5,0A29.5,29.5,0,1,1,0,29.5,29.5,29.5,0,0,1,29.5,0Z",
    transform: "translate(158 109)",
    fill: "#f0dbf2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "np_gym_2899436_000000",
    d: "M44.495,28.13h-4.4V25.49a.881.881,0,0,0-.88-.88H33.932a.881.881,0,0,0-.88.88v5.281h-17.6V25.49a.881.881,0,0,0-.88-.88H9.287a.881.881,0,0,0-.88.88V28.13h-4.4a.881.881,0,0,0-.88.88V43.094a.881.881,0,0,0,.88.88h4.4v2.641a.881.881,0,0,0,.88.88h5.281a.881.881,0,0,0,.88-.88V41.333h17.6v5.281a.881.881,0,0,0,.88.88h5.281a.881.881,0,0,0,.88-.88V43.974h4.4a.881.881,0,0,0,.88-.88V29.01A.881.881,0,0,0,44.495,28.13ZM4.885,42.213V29.891H8.406V42.213Zm8.8,3.521H10.167V26.37h3.521Zm1.76-6.161V32.531h17.6v7.042Zm22.885,6.161H34.812V26.37h3.521Zm5.281-3.521H40.093V29.891h3.521Z",
    transform: "translate(-2178.098 -5561.431) rotate(-31)",
    fill: "#121e59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineGym);
export default __webpack_public_path__ + "static/media/onlineGym.c47ccab93121e4dba62874caed58d91a.svg";
export { ForwardRef as ReactComponent };